export default function deepGetState(state, keyMap, defaultValue) {
  const tmp = keyMap.split('.');
  const topKey = tmp[0];
  let currentKey = topKey;
  let data;

  if (tmp.length === 1) {
    data = state[topKey];
    return data === undefined ? defaultValue : data;
  }

  const check = () => {
    if (data === '___dn-ls-undefined___' || data === undefined) {
      data = {};
    } else if (data === null || typeof data !== 'object') {
      console.warn(state);
      throw new Error(`「${keyMap}」の値を参照できませんでした。「${currentKey}」にはオブジェクトに解決できない値が入っています。`)
    }
  }

  data = state[topKey];
  data = data === undefined ? '___dn-ls-undefined___' : data;
  check();

  for (let i = 1, l = tmp.length - 1; i < l; i++) {
    data = data[tmp[i]];
    currentKey += '.' + tmp[i];
    check();
  }

  data = data[tmp[tmp.length - 1]];
  return data === undefined ? defaultValue : data;
}



// WEBPACK FOOTER //
// ./src/js/store/modules/ls/util/deepGetState.js